module.exports = __webpack_public_path__ + "img/bg_ding@2x.40693dfd.png";